export default "__VITE_ASSET__DA3ql4zu__"